<template>
  <div>
    <JoinWrapper>
      <div class="mobile_device">
        <!-- PROGRESS BAR -->
        <JoinProgress :stage="stage" />
        <!-- / PROGRESS BAR -->
        <div class="topic">아이디/비밀번호 설정</div>
        <div
          class="id_wrap"
          :class="{
            incorrect: hasValidated && username && invalidEmail,
            correct: hasValidated && !invalidEmail
          }"
        >
          <span class="id_txt txt_style">아이디</span>
          <label for="user_email">
            <input
              id="user_email"
              v-model="username"
              class="input_t"
              :class="{ 'put-chk': usernameHasInput }"
              type="email"
              name="email"
              title="이메일"
              placeholder="example@example.com"
              :readonly="verifiedInfo.type === 'email'"
              @input="handleInput"
            />
            <button
              type="submit"
              class="duplication_chk"
              :class="{ dull: !username }"
              :disabled="!username"
              @click="handleEmailValidation"
            >
              중복확인
            </button>
          </label>
          <p class="txt_message">
            <span>
              {{
                invalidEmail
                  ? $t('views.auth.join.joinstep3.invalidemail')
                  : '이 아이디는 사용하실 수 있습니다.'
              }}
            </span>
          </p>
        </div>
        <div
          class="password_wrap"
          :class="{
            incorrect: password && invalidPassword,
            correct: password && !invalidPassword
          }"
        >
          <span class="password_txt txt_style">비밀번호</span>
          <label for="user_password">
            <input
              id="user_password"
              v-model="password"
              class="input_t"
              :class="{ 'put-chk': passwordHasInput }"
              :type="inputType_first"
              maxlength="16"
              name="password"
              title="비밀번호"
              placeholder="비밀번호를 입력해 주세요"
              @blur="validatePassword"
              @keydown.enter="validatePassword"
              @keyup="validatePassword"
              @keydown="validatePassword"
              @keypress="validatePassword"
            />
            <button
              type="button"
              class="password_toggle"
              @click="passwordToggle(0)"
            >
              <div v-if="inputType_first === 'password'">
                <img
                  src="@/assets/images/login_join/encryption.png"
                  alt="비밀번호토글닫힘"
                />
              </div>
              <div v-else>
                <img
                  src="@/assets/images/login_join/encryption_on.png"
                  alt="비밀번호토글열림"
                />
              </div>
            </button>
          </label>
          <p class="txt_message">
            <span>
              {{
                invalidPassword
                  ? $t('views.auth.join.joinstep3.invalidpw')
                  : $t('views.auth.join.joinstep3.validpw')
              }}
            </span>
          </p>
        </div>
        <div
          class="pwChk_wrap"
          :class="{
            incorrect: passwordCheck && invalidPasswordMatch,
            correct: passwordCheck && !invalidPasswordMatch
          }"
        >
          <span class="pwChk_txt txt_style">비밀번호 확인</span>
          <label for="user_password_check">
            <input
              id="user_password_check"
              v-model="passwordCheck"
              class="input_t"
              :class="{ 'put-chk': passwordChkHasInput }"
              :type="inputType_second"
              maxlength="16"
              name="password"
              title="비밀번호 확인"
              placeholder="비밀번호를 다시 입력해 주세요"
              @blur="validatePasswordMatch"
              @keydown.enter="validatePasswordMatch"
              @keyup="validatePasswordMatch"
              @keydown="validatePasswordMatch"
              @keypress="validatePasswordMatch"
            />
            <button
              type="button"
              class="password_toggle"
              @click="passwordToggle(1)"
            >
              <div v-if="inputType_second === 'password'">
                <img
                  src="@/assets/images/login_join/encryption.png"
                  alt="비밀번호토글닫힘"
                />
              </div>
              <div v-else>
                <img
                  src="@/assets/images/login_join/encryption_on.png"
                  alt="비밀번호토글열림"
                />
              </div>
            </button>
          </label>
          <p class="txt_message">
            <span>
              {{
                invalidPasswordMatch
                  ? $t('views.auth.join.joinstep3.invalidpw2')
                  : $t('views.auth.join.joinstep3.validpw2')
              }}
            </span>
          </p>
        </div>
        <div class="btn_wrap">
          <button
            class="box_btn next_btn"
            :class="{ dull: !isValid }"
            :disabled="!isValid"
            @click="registerUser"
          >
            다음
          </button>
        </div>
      </div>
      <!-- ERROR MODAL -->
      <transition v-on-clickaway="closeErrorModal" name="modal-fade">
        <Modal v-if="showErrorModal" @close="closeErrorModal">
          <div class="ly_pop_wrap">
            <div class="ly_pop_content ly_pop_msg ly_txt">
              <div class="ly_pop_head">
                <a class="btn_ly_close svg_close" @click="closeErrorModal"
                  ><span>{{ $t('library.deletemodal.close') }}</span></a
                >
              </div>
              <div class="ly_inner">
                <p>
                  {{ errorMessage ? errorMessage : getAuthErrorMessage }}
                </p>
                <div class="btn_wrap">
                  <button class="box_btn" @click="toggleErrorModal">
                    <span class="an_t">{{
                      $t('library.deletemodal.close')
                    }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </transition>
    </JoinWrapper>
  </div>
</template>

<script>
import JoinWrapper from '@/components/auth/JoinWrapper.vue'
import JoinProgress from '@/components/auth/JoinProgress.vue'
import { AUTH_CHECK_USERNAME } from '@/store/types'

import { mapGetters } from 'vuex'

export default {
  name: 'JoinStep3',

  components: {
    JoinProgress,
    JoinWrapper
  },
  data() {
    return {
      stage: 3,
      hasValidated: false,
      name: '',
      email: '',
      username: '',
      password: '',
      passwordCheck: '',
      usernameHasInput: false,
      passwordHasInput: false,
      passwordChkHasInput: false,
      invalidEmail: true,
      invalidPassword: true,
      invalidPasswordMatch: true,
      verifiedInfo: null,
      showErrorModal: false,
      errorMessage: '',
      isKorean: false,
      inputType_first: 'password',
      inputType_second: 'password',
      contactMethods: this.$route.params.contactMethods,
      formattedPhone: ''
    }
  },
  computed: {
    ...mapGetters(['getAuthErrorMessage', 'getRegisterMemberType']),
    isValid() {
      const commonConditions =
        !this.invalidEmail &&
        !this.invalidPassword &&
        !this.invalidPasswordMatch
      if (commonConditions && this.username && this.hasValidated) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    username(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.hasValidated = false
      }
    }
  },
  beforeMount() {
    if (!this.$route.params.verifiedInfo) {
      this.$router.push({ name: 'sign_up' })
    }
    this.verifiedInfo = this.$route.params.verifiedInfo || {}
    this.name = this.verifiedInfo.name || ''
    if (this.verifiedInfo.type === 'phone') {
      this.isKorean = true
    }
    if (this.verifiedInfo.type === 'email') {
      this.username = this.verifiedInfo.email
      return
    }
    const phoneNumber = this.$route.params?.verifiedInfo.phone
    const formattedPhone = phoneNumber.replace(
      /^0(\d{2})(\d{4})(\d{4})$/,
      '82-0$1-$2-$3'
    )
    this.formattedPhone = formattedPhone
  },
  beforeDestroy() {
    // this.$store.dispatch('setCookie', {
    //   name: 'ealice_mail2',
    //   value: '',
    //   exp: 0
    // })
  },
  methods: {
    passwordToggle(index) {
      if (index === 0) {
        this.inputType_first =
          this.inputType_first === 'password' ? 'text' : 'password'
      } else if (index === 1) {
        this.inputType_second =
          this.inputType_second === 'password' ? 'text' : 'password'
      }
    },
    handleInput() {
      this.hasValidated = false
    },
    handleEmailValidation() {
      this.hasValidated = true
      this.validateEmail()
    },
    async validateEmail() {
      if (this.verifiedInfo.email) {
        return
      }
      const { username } = this
      if (!username) return
      try {
        await this.$store.dispatch(AUTH_CHECK_USERNAME, username)
        this.invalidEmail = false
      } catch {
        this.invalidEmail = true
      }
    },
    validatePassword() {
      if (this.password.length > 15 || this.password.length < 10) {
        this.invalidPassword = true
      } else {
        this.invalidPassword = false
      }
    },
    validatePasswordMatch() {
      if (this.password !== this.passwordCheck) {
        this.invalidPasswordMatch = true
      } else {
        this.invalidPasswordMatch = false
      }
    },
    formatRegisterData() {
      let data = {}

      data.name = this.$route.params?.verifiedInfo.name
      data.birthday = this.$route.params?.verifiedInfo.birthday
      data.loginId = this.username
      data.loginPwd = btoa(this.password)
      data.mobileNo = this.formattedPhone
      data.gender = this.$route.params?.verifiedInfo.genderCode
      // data.registerTp = this.verifiedInfo.email ? 'EM' : 'MO'
      data.impUid = this.$route.params?.verifiedInfo.impUid
      data.merchantUid = this.$route.params?.verifiedInfo.merchantUid
      data = {
        ...data
      }
      return data
    },
    async registerUser() {
      this.errorMessage = ''
      let valid = ''
      if (valid) {
        this.errorMessage = this.$i18n.t('views.auth.join.joinstep3.fillfields')
        this.toggleErrorModal()
        return
      }
      const data = this.formatRegisterData()
      try {
        this.$router.push({
          name: 'join_step4',
          params: { data: data, contactMethods: this.contactMethods }
        })
      } catch (err) {
        this.toggleErrorModal()
      }
    },
    closeErrorModal() {
      this.showErrorModal = false
      this.erorrMessage = ''
    },
    toggleErrorModal() {
      this.showErrorModal = !this.showErrorModal
    }
  }
}
</script>
<style lang="scss" scoped>
input::placeholder {
  color: #979797;
}
.input_t {
  &:focus {
    border: 1px solid #008df3;
  }
}
.txt_message {
  height: auto;
}
.id_wrap,
.password_wrap {
  margin-bottom: 24px;
}
.correct {
  .txt_message {
    span {
      color: #008df3;
    }
  }
  // .input_t {
  //   border: 1px solid #008df3;
  // }
}
.pwChk_wrap {
  margin-bottom: 200px;
}
.duplication_chk {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 16px;
  letter-spacing: 0;
  font-family: 'pretendard-medium';
  font-size: 16px;
  opacity: 1;
  color: #008df3;
  &.dull {
    opacity: 0.5;
  }
}
label[for='user_email'] {
  position: relative;
}
label[for='user_password'],
label[for='user_password_check'] {
  position: relative;
  display: block;
  .password_toggle {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 14px;
    width: 24px;
    height: 24px;
    > img {
      width: 100%;
    }
  }
}
</style>
